import BaseException from './base_exception'

class InvalidFileType extends BaseException {
  constructor(fileTypeName) {
    super('hs.errors.file.invalid_type', { fileTypeName })
  }
}

export default InvalidFileType
